import { render } from "./GroupAddOrRemove.vue?vue&type=template&id=8eee8560&scoped=true"
import script from "./GroupAddOrRemove.vue?vue&type=script&lang=js"
export * from "./GroupAddOrRemove.vue?vue&type=script&lang=js"

import "./GroupAddOrRemove.vue?vue&type=style&index=0&id=8eee8560&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eee8560"]])

export default __exports__